module.exports = __webpack_public_path__ + "static/media/cornerMatGery95.b1153f72.png";